<div class="wrapper">
  <span class="label-text" translate>{{labelKey}}</span>
  <span class="value">{{value}}</span>
</div>
